import { NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormMode } from 'src/app/controls/common/form-mode';

@Component({
    selector: 'app-box-form-dialog',
    templateUrl: './box-form-dialog.component.html',
    styleUrls: ['./box-form-dialog.component.scss'],
    imports: [MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatButtonModule, NgClass, MatDialogClose]
})
export class BoxFormDialogComponent implements OnInit {
    public FormMode = FormMode;

    /**
     * Champs du formulaire de saisie du nom.
     */
    public nameFormControl = new UntypedFormControl(null, Validators.required);
    public orderFormControl = new UntypedFormControl(null);
    public idFormControl = new UntypedFormControl(null);

    // public reminderActionDatasFormControl = new FormControl(null, Validators.required);

    public get isValid(): boolean {
        return this.nameFormControl.valid;
    }

    public title = "Ajout d'une bannette";

    constructor(
        public dialogRef: MatDialogRef<BoxFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {}

    ngOnInit(): void {
        this.idFormControl.disable();
        this.orderFormControl.disable();

        if (this.data.mode === FormMode.Reading) {
            this.nameFormControl.disable();
        }

        if (this.data.mode === FormMode.Creation) {
            this.title = "Ajout d'une bannette";
        } else if (this.data.mode === FormMode.Edition) {
            this.title = `Édition de la bannette ${this.data.record.id}`;
        }
        if (this.data.mode === FormMode.Reading) {
            this.title = `Bannette  ${this.data.record.id}`;
        }
    }

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Appelé lorsque l'utilisateur clique sur le bouton 'Valider'.
     */
    public validate(): void {
        if (this.isValid) {
            this.dialogRef.close(this.data.record);
        }
    }
}
